module.exports = __webpack_public_path__ + "static/media/arrow-line-left.049c591a.svg";